import { Store } from "redux";
import { SET_DELIVERY } from "./store";
import { constants } from "../../components/ticketing/common";
import { EventEmitter, postJson, trackEvent } from "../../utils";
import { reportError } from "../../components/ticketing/basket-v2/errorReporting";
import { ApiResponse } from "../../components/ticketing/basket-v2/api/models";
import { SetDeliveryMethodRequest } from "../../components/ticketing/basket-v2/api/models";
import { events } from "../constants";

export class DeliveryOptions {
  element: HTMLElement | null;
  store: Store;
  checkoutPageId: HTMLInputElement | null;
  defaultError = {code: 0,  message: "Error setting the delivery method"};

  constructor(selector: string, store: Store) {
    this.store = store;
    this.element = document.querySelector<HTMLElement>(selector);
    this.checkoutPageId = document.querySelector<HTMLInputElement>("#checkoutPageId");

    if (!this.element || !this.checkoutPageId) return;

    this.bindEvents();
  }

  handleDeliveryChange = async (e: Event) => {

    try {

      EventEmitter.emit(events.ORDER_UPDATE_START);

      const target = e.target as HTMLInputElement;    
      const request: SetDeliveryMethodRequest = {
        checkoutPageId: parseInt(this.checkoutPageId?.value ?? "0"),
        deliveryMethod: target.dataset.deliveryType ?? "0"
      };
      
      const response = await postJson<ApiResponse>(constants.urls.basketV2.delivery_method, request);

      if(!response.success) {
        const error = response?.errors[0] ?? this.defaultError;
        reportError(error.code, error.message);
        return;
      }

      this.storeDeliveryMethod(target.dataset.deliveryType ?? "0", parseFloat(target.value));

    } catch (e) {
        console.log(e);
        reportError(this.defaultError.code, e.message ?? this.defaultError.message );
        EventEmitter.emit(events.ORDER_UPDATE_END);
    }
  };

  storeDeliveryMethod(deliveryType: String | null, deliveryCost: Number | null) {
    this.store.dispatch({
      type: SET_DELIVERY,
      payload: {
        type: deliveryType,
        cost: deliveryCost,
      },
    });

    trackEvent({
      event: 'checkout',
      category: 'Checkout',
      action: 'Set Delivery Method',
      label: deliveryType.toString()
    });
  }

  bindEvents() {
    if(this,this.element) {
      this.element.addEventListener("change", this.handleDeliveryChange, true);
    }
  }
}
